import { IPublishTermsSchema } from '../../../../repositories/monolith-python/entities/publish_terms/PublishTermsSchema';
import { IPublicationTokens } from '../../../../types/reducers/publishTerms';

interface IParams {
  isAutoprolongChecked: boolean;
  publicationTokens: IPublicationTokens;
  terms: any;
}

export const mapPublishTerms = ({ isAutoprolongChecked, publicationTokens, terms }: IParams): IPublishTermsSchema => {
  return {
    autoprolong: isAutoprolongChecked,
    usePromotionFromAuction: false,
    publication: publicationTokens,
    terms,
  } as unknown as IPublishTermsSchema;
};
